import React from 'react';
import { Loader2 } from 'lucide-react';

export default function AuthLoader() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-slate-500" />
    </div>
  );
}
